import { useState, useEffect } from "react";
import { MdCancel, MdCheckCircle } from "react-icons/md";
import { Dropdown, DropdownButton, Form, Accordion } from "react-bootstrap";
import { IoLogoWhatsapp } from "react-icons/io";
import axios from "axios";
import { toast } from "react-toastify";
import NoData from "../../components/NoData";
import ExportModal from "../../components/Modals/ExportsModel/main";
import ImportModal from "../../components/Modals/ImportModel";
import { BASE_URL, HEADERS } from "../../utils/constant";
import CustomerModal from "../../components/Modals/CreateCustomerModel";

import Loader from "../../components/Loader";
import { BsThreeDotsVertical } from "react-icons/bs";
import {
  FaEdit,
  FaFileExport,
  FaFileImport,
  FaPlus,
  FaTrashAlt,
  FaUserCircle,
} from "react-icons/fa";
import { useCommonContext } from "../../utils/context";
import SubCustomerListModel from "../../components/Modals/SubCustomerListModel";
import { useTypeConfig } from "../../utils/useTypeConfig";
import CommonButton from "../../components/CommonButton";
import Pagination from "../../components/Pagination";

function Customer() {
  const [showSubModal, setShowSubModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);

  const [searchText, setSearchText] = useState("");

  const { labels, hiddenFields } = useTypeConfig();
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [pagecustomers, setCustomers] = useState([]);

  const [loading, setLoading] = useState(false);
  const [fetchedTags, setFetchedTags] = useState([]);
  const [editCustomerData, setEditCustomerData] = useState(null);

  const [selectedCustomer, setSelectedCustomer] = useState([]);

  const [exportLoading] = useState(false);
  const [itemOffset] = useState(0);
  const [statusFilter, setStatusFilter] = useState("active");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const [itemsPerPage, setItemsPerPage] = useState(10);

  const endOffset = itemOffset + itemsPerPage;
  const currentItems = pagecustomers.slice(itemOffset, endOffset);
  const { fetchCustomers: fetchActiveCustomers } = useCommonContext();
  const role = localStorage.getItem("role");

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage, itemsPerPage, searchText, statusFilter]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchText]);

  const fetchCustomers = async (page = 1) => {
    setLoading(true);
    try {
      let url = `${BASE_URL}/users/tms_users/?role=customer`;

      const response = await axios.get(url, {
        headers: HEADERS,
        params: {
          page: page,
          page_size: itemsPerPage,
          search: searchText || undefined,
          is_active: statusFilter,
        },
      });
      if (response.data && response.data.results) {
        setCustomers(response.data.results || []);

        setTotalPages(response.data.total_pages);

        setCurrentPage(page);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setCurrentPage(1);
        fetchCustomers(1);
      } else {
      }
    } finally {
      setLoading(false);
    }
  };

  const handleViewSub = (customer) => {
    setSelectedCustomer(customer);
    setShowSubModal(true);
  };
  const handleEditCustomer = (customer) => {
    setEditCustomerData(customer);
    setShowCustomerModal(true);
  };

  const handleAddCustomer = () => {
    setEditCustomerData(null);
    setShowCustomerModal(true);
  };

  const handleToggleActive = async (customerId, currentStatus) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/users/tms_users/${customerId}/`,
        { is_active: !currentStatus },
        {
          headers: {
            ...HEADERS,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200) {
        toast.success(
          `Customer ${
            currentStatus ? "deactivated" : "activated"
          } successfully!`,
        );

        setCustomers((prevCustomers) =>
          prevCustomers?.map((customer) =>
            customer.id === customerId
              ? { ...customer, is_active: !currentStatus }
              : customer,
          ),
        );
        fetchActiveCustomers();
      } else {
        toast.error("Failed to update customer status. Please try again.");
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorData = error.response.data.error;

        if (typeof errorData === "object" && !Array.isArray(errorData)) {
          Object.entries(errorData).forEach(([field, messages]) => {
            if (Array.isArray(messages)) {
              messages.forEach((message) => {
                toast.error(`${message}`);
              });
            } else {
              toast.error(`${messages}`);
            }
          });
        } else {
          toast.error("Unexpected error format. Please try again.");
        }
      } else {
        toast.error("Error Please Try again.");
      }
    }
  };

  const handleDeleteCustomer = async (customerId) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/users/tms_users/${customerId}/`,
        {
          headers: {
            ...HEADERS,
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (response) {
        toast.success("Customer deleted successfully!");

        setCustomers((prev) =>
          prev.filter((customer) => customer.id !== customerId),
        );
        fetchCustomers(currentPage);
      } else {
        toast.error("Failed to delete customer. Please try again.");
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorData = error.response.data.error;

        if (typeof errorData === "object" && !Array.isArray(errorData)) {
          Object.entries(errorData).forEach(([field, messages]) => {
            if (Array.isArray(messages)) {
              messages.forEach((message) => {
                toast.error(`${message}`);
              });
            } else {
              toast.error(`${messages}`);
            }
          });
        } else {
          toast.error("Unexpected error format. Please try again.");
        }
      } else {
        toast.error("Error Please Try again.");
      }
    }
  };

  const handleCloseModals = () => {
    setEditCustomerData(null);
    setShowCustomerModal(false);
    setShowImportModal(false);
    setShowSubModal(false);
  };

  const handlePageClick = (selectedPage) => {
    const newPage = selectedPage.selected + 1;
    setCurrentPage(newPage);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const isAddressEmpty = (address) => {
    return (
      !address?.primary_address &&
      !address?.city &&
      !address?.landmark_paci &&
      !address?.state &&
      !address?.zipcode &&
      !address?.country
    );
  };

  return (
    <div className="container-fluid ">
      <div className="mt-3 d-flex  container-header flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
        <h4 className="mb-md-0">{labels.customerList}</h4>

        <div className="d-none d-md-flex align-items-center gap-2">
          <Form.Control
            type="text"
            value={searchText}
            className="uniform-input search-text"
            placeholder="Search Here..."
            onChange={(e) => setSearchText(e.target.value)}
          />

          <Form.Select
            value={
              statusFilter === true
                ? "is_active"
                : statusFilter === false
                  ? "!is_active"
                  : ""
            }
            onChange={(e) => {
              const value = e.target.value;
              if (value === "is_active") {
                setStatusFilter(true);
              } else if (value === "!is_active") {
                setStatusFilter(false);
              } else {
                setStatusFilter(null);
              }
            }}
            className="uniform-input"
          >
            <option value="">All</option>
            <option value="is_active">Active</option>
            <option value="!is_active">Inactive</option>
          </Form.Select>

          <CommonButton className="uniform-button" onClick={handleAddCustomer}>
            <FaPlus style={{ marginRight: "6px" }} /> Add
          </CommonButton>
          <CommonButton
            className="uniform-button"
            onClick={() => setShowImportModal(true)}
          >
            <FaFileImport style={{ marginRight: "6px" }} /> Import
          </CommonButton>

          <CommonButton
            className="uniform-button"
            onClick={() => setShowExportModal(true)}
            disabled={exportLoading || currentItems.length === 0}
          >
            <FaFileExport style={{ marginRight: "6px" }} /> Export
          </CommonButton>
        </div>

        <div className="d-md-none w-100">
          <Accordion flush>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Filters & Actions</Accordion.Header>
              <Accordion.Body className="d-flex flex-column gap-3">
                <Form.Control
                  type="text"
                  value={searchText}
                  className="uniform-input search-text"
                  placeholder="Search Here..."
                  onChange={(e) => setSearchText(e.target.value)}
                />

                <Form.Select
                  value={
                    statusFilter === true
                      ? "is_active"
                      : statusFilter === false
                        ? "!is_active"
                        : ""
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "is_active") {
                      setStatusFilter(true);
                    } else if (value === "!is_active") {
                      setStatusFilter(false);
                    } else {
                      setStatusFilter(null);
                    }
                  }}
                  className="uniform-input"
                >
                  <option value="">All</option>
                  <option value="is_active">Active</option>
                  <option value="!is_active">Inactive</option>
                </Form.Select>
                <div className="d-flex flex-wrap gap-2 justify-content-start mt-3">
                  <CommonButton
                    className="uniform-button w-100 d-flex justify-content-center align-items-center"
                    onClick={handleAddCustomer}
                  >
                    <FaPlus style={{ marginRight: "6px" }} /> Add
                  </CommonButton>

                  <CommonButton
                    className="uniform-button w-100 d-flex justify-content-center align-items-center"
                    onClick={() => setShowImportModal(true)}
                  >
                    <FaFileImport style={{ marginRight: "6px" }} /> Import
                  </CommonButton>

                  <CommonButton
                    className="uniform-button w-100 d-flex justify-content-center align-items-center"
                    onClick={() => setShowExportModal(true)}
                    disabled={exportLoading || currentItems.length === 0}
                  >
                    <FaFileExport style={{ marginRight: "6px" }} /> Export
                  </CommonButton>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>

      <div
        className={`table-responsive ${currentItems.length === 0 ? "" : "tabell"} `}
      >
        {loading ? (
          <Loader />
        ) : (
          <>
            {currentItems.length > 0 ? (
              <table className="table  tstart">
                <thead className="thead">
                  <tr style={{ whiteSpace: "nowrap" }}>
                    <th style={{ width: "350px" }}>{labels.customerName}</th>
                    <th style={{ width: "300px" }}>{labels.companyName}</th>
                    <th style={{ width: "300px" }}>Email</th>
                    <th style={{ width: "200px" }}>Phone</th>
                    <th style={{ width: "200px" }}>Region</th>
                    <th style={{ width: "400px" }}>Address</th>
                    {!hiddenFields.includes("productModel") && (
                      <>
                        <th style={{ width: "400px" }}>Product Names</th>
                        <th style={{ width: "200px" }}>Model No.</th>
                      </>
                    )}
                    <th style={{ width: "150px" }}>Since</th>
                    <th style={{ width: "150px" }}>Status</th>
                    <th style={{ width: "150px" }}></th>
                    <th style={{ width: "150px" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((customer, index) => (
                    <tr
                      key={customer.id}
                      className="tbody"
                      onClick={() => handleViewSub(customer)}
                    >
                      <td>
                        <div className="d-flex align-items-center ">
                          <span className="badge bg-primary text-white me-2">
                            {customer.id}
                          </span>
                          <div className="me-2 position-relative">
                            {customer.profile_image ? (
                              <img
                                src={customer.profile_image}
                                alt="Profile"
                                className="rounded-circle"
                                style={{
                                  width: "30px",
                                  height: "30px",
                                  objectFit: "cover",
                                }}
                              />
                            ) : (
                              <FaUserCircle
                                size={30}
                                className="text-secondary"
                              />
                            )}
                          </div>

                          <div
                            title={customer.customer_name || "—"}
                            className="tdsubject"
                          >
                            {customer.customer_name || "—"}
                          </div>
                        </div>
                      </td>

                      <td>
                        <div
                          title={customer.company_name || "—"}
                          className="tdsubject"
                        >
                          {customer.company_name || "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={customer.email || "—"}
                          className="tdsubject"
                        >
                          {customer.email || "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={customer.phone_number || "—"}
                          className="tdsubject"
                        >
                          {customer.phone_number || "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={customer.region || "—"}
                          className="tdsubject"
                        >
                          {customer.region || "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={
                            isAddressEmpty(customer)
                              ? "—"
                              : `${customer?.primary_address || ""} ${
                                  customer?.city || ""
                                } ${customer?.landmark_paci || ""} ${
                                  customer?.state || ""
                                } ${customer?.zipcode || ""} ${
                                  customer?.country || ""
                                }`.trim()
                          }
                          className="tdsubject "
                        >
                          {isAddressEmpty(customer) ? (
                            "—"
                          ) : (
                            <div className="tdsubject ">
                              {customer?.primary_address && (
                                <strong>{customer?.primary_address}</strong>
                              )}
                              {(customer?.city ||
                                customer?.landmark_paci ||
                                customer?.state) && (
                                <>
                                  <br />
                                  {customer?.city && <>{customer?.city}</>}
                                  {customer?.landmark_paci && (
                                    <>
                                      {customer?.city ? ", " : ""}
                                      {customer?.landmark_paci}
                                    </>
                                  )}
                                  {customer?.state && (
                                    <>
                                      {customer?.city || customer?.landmark_paci
                                        ? ", "
                                        : ""}
                                      {customer?.state}
                                    </>
                                  )}
                                </>
                              )}
                              {(customer?.zipcode || customer?.country) && (
                                <>
                                  {customer?.zipcode && (
                                    <>{customer?.zipcode}</>
                                  )}
                                  {customer?.country && (
                                    <>
                                      {customer?.zipcode ? ", " : ""}
                                      {customer?.country}
                                    </>
                                  )}
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      </td>
                      {!hiddenFields.includes("productModel") && (
                        <>
                          <td>
                            <div
                              title={
                                customer.brand_names
                                  ?.map((brand) => brand.name)
                                  .join(", ") || "---"
                              }
                              className="tdsubject"
                            >
                              {customer.brand_names
                                ?.map((brand) => brand.name)
                                .join(", ") || "---"}
                            </div>
                          </td>

                          <td>
                            <div
                              title={customer.model_no || "---"}
                              className="tdsubject"
                            >
                              {customer.model_no || "---"}
                            </div>
                          </td>
                        </>
                      )}

                      <td>
                        <div
                          title={customer.created_at || "—"}
                          className="tdsubject"
                        >
                          {customer.created_at || "—"}
                        </div>
                      </td>

                      <td>
                        <span
                          className={`badge ${
                            customer.is_active ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {customer.is_active ? "Active" : "Inactive"}
                        </span>
                      </td>

                      <td>
                        <a
                          href={`https://api.whatsapp.com/send/?phone=${encodeURIComponent(
                            `+91${customer.phone_number}`,
                          )}&text=Hello`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-success"
                        >
                          <IoLogoWhatsapp size={16} />
                        </a>
                      </td>
                      <td style={{ padding: "2px" }}>
                        <DropdownButton
                          id="dropdown-basic-button"
                          title={<BsThreeDotsVertical />}
                          variant="link"
                          className="p-0 text-secondary custom-dropdown"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Dropdown.Item
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEditCustomer(customer);
                            }}
                          >
                            <FaEdit className="me-1" /> Edit
                          </Dropdown.Item>
                          {role === "admin" && (
                            <Dropdown.Item
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeleteCustomer(customer.id);
                              }}
                            >
                              <FaTrashAlt className="me-1" /> Delete
                            </Dropdown.Item>
                          )}
                          <Dropdown.Item
                            as="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleToggleActive(
                                customer.id,
                                customer.is_active,
                              );
                            }}
                          >
                            {customer.is_active ? (
                              <>
                                <MdCancel className="me-1" /> Deactivate
                              </>
                            ) : (
                              <>
                                <MdCheckCircle className="me-1" /> Activate
                              </>
                            )}
                          </Dropdown.Item>
                        </DropdownButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <NoData message="No Data Found" height="400px" />
            )}
          </>
        )}
      </div>

      {currentItems.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          handlePageClick={handlePageClick}
          handleItemsPerPageChange={handleItemsPerPageChange}
        />
      )}

      <CustomerModal
        show={showCustomerModal}
        handleClose={handleCloseModals}
        customerData={editCustomerData}
        fetchCustomers={() => fetchCustomers(currentPage)}
        fetchedTags={fetchedTags}
      />

      <SubCustomerListModel
        show={showSubModal}
        handleClose={handleCloseModals}
        cusId={selectedCustomer.id}
        selectedCustomer={selectedCustomer}
        customers={pagecustomers}
        fetchCustomers={fetchCustomers}
      />

      <ImportModal
        show={showImportModal}
        handleClose={handleCloseModals}
        type="customers"
        onSuccess={() => fetchCustomers(currentPage)}
      />
      <ExportModal
        show={showExportModal}
        handleClose={() => setShowExportModal(false)}
        title="customers"
      />
    </div>
  );
}

export default Customer;
